import type { Collaborators, CrossJoinTargetProduct } from '../../common/types';

type AccountIds = string[];

export const getCollaboratorsWithJiraAccess = async (
	cloudId: string,
	collaborators: Collaborators,
): Promise<Collaborators> => {
	const accountIds = collaborators.map((c) => c.id);
	const response = await fetch(
		'/gateway/api/growth/cross-join-nudges-v3/get-permitted-jira-users',
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				cloudId,
				accountIds,
			}),
		},
	);

	const returnedAccountIds = (await response.json()) as AccountIds;
	return collaborators.filter((c) => returnedAccountIds.includes(c.id));
};

export const getUsersWithProductAccess = async (
	product: CrossJoinTargetProduct,
	cloudId: string,
	collaborators: Collaborators,
): Promise<Collaborators> => {
	const response = await fetch('/gateway/api/growth/invite-on-link-insert/get-invitees', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			cloudId,
			product,
			accountIds: collaborators.map((c) => c.id),
		}),
	});

	const returnedAccountIds = (await response.json()) as AccountIds;
	return collaborators.filter((c) => !returnedAccountIds.includes(c.id));
};
